// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { collabEditPlugin } from '@atlaskit/editor-plugin-collab-edit';
export type {
	CollabEditPlugin,
	CollabEditPluginOptions,
	CollabInitializedMetadata,
	CollabEditPluginSharedState,
	ReadOnlyParticipants,
	PrivateCollabEditOptions,
	CollabSendableSteps,
} from '@atlaskit/editor-plugin-collab-edit';
